var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "nav",
      {
        staticClass: "breadcrumb is-small",
        attrs: { "aria-label": "breadcrumbs" }
      },
      [
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "/project/" + _vm.dataID } }, [
              _vm._v("Project: " + _vm._s(_vm.dataID))
            ])
          ]),
          _vm._m(0)
        ])
      ]
    ),
    _vm._m(1),
    _c("div", { staticClass: "box" }, [
      _c("h3", { staticClass: "title is-3" }, [
        _vm._v("Detail Of Production Task")
      ]),
      _c("h5", { staticClass: "subtitle is-4" }, [_vm._v(_vm._s(_vm.dataID))]),
      _c("table", { staticClass: "table" }, [
        _vm._m(2),
        _c(
          "tbody",
          _vm._l(_vm.listTask, function(item) {
            return _c("tr", { key: item.prodTaskID }, [
              _c("td", [
                _c("span", { class: "lbl is-status-" + item.prodTaskStatus }, [
                  _vm._v(_vm._s(item.prodTaskStatus))
                ])
              ]),
              _c(
                "td",
                [
                  _c(
                    "nuxt-link",
                    { attrs: { to: "/project/tasks/view/" + item.prodTaskID } },
                    [_vm._v(" " + _vm._s(item.prodTaskID) + " ")]
                  )
                ],
                1
              ),
              _c("td", [_vm._v(_vm._s(item.prodTaskName))]),
              _c("td", [
                _vm._v(_vm._s(item.vendorID) + " " + _vm._s(item.vendorName))
              ]),
              _c("td", [_vm._v(_vm._s(_vm._f("Date")(item.estStartDate)))]),
              _c("td", [_vm._v(_vm._s(_vm._f("Date")(item.estFinishDate)))]),
              _c("td", [
                _c(
                  "a",
                  {
                    staticClass: "button is-small is-info",
                    attrs: { href: _vm.createEditUrl(item.prodTaskID) }
                  },
                  [_c("i", { staticClass: "fa fa-edit" }), _vm._v(" Edit")]
                ),
                _vm._v(" \n                ")
              ])
            ])
          })
        )
      ])
    ]),
    _c("div", { staticClass: "box" }, [
      _vm._m(3),
      _c("form", { attrs: { action: "#", id: "frmCreate", method: "post" } }, [
        _c("div", { staticStyle: { width: "75%" } }, [
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(4),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.taskModel.prodTaskName,
                      expression: "taskModel.prodTaskName"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "text", placeholder: "" },
                  domProps: { value: _vm.taskModel.prodTaskName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.taskModel,
                        "prodTaskName",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(5),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control is-expanded" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.taskModel.prodDetail,
                        expression: "taskModel.prodDetail"
                      }
                    ],
                    staticClass: "textarea",
                    attrs: { name: "detail", id: "detail", rows: "3" },
                    domProps: { value: _vm.taskModel.prodDetail },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.taskModel,
                          "prodDetail",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(6),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.vendorData,
                            expression: "vendorData"
                          }
                        ],
                        attrs: { name: "PartnerName" },
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.vendorData = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            function($event) {
                              _vm.selectVendor()
                            }
                          ]
                        }
                      },
                      _vm._l(_vm.listPartner, function(item, index) {
                        return _c(
                          "option",
                          { key: item.id, domProps: { value: index } },
                          [
                            _vm._v(
                              _vm._s(item["partner.id"]) +
                                " : " +
                                _vm._s(item["partner.partnerName"])
                            )
                          ]
                        )
                      })
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(7),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control is-expanded" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.taskModel.reqLeadTime,
                        expression: "taskModel.reqLeadTime"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "number", name: "leadTime", id: "LeadTime" },
                    domProps: { value: _vm.taskModel.reqLeadTime },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.taskModel,
                          "reqLeadTime",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(8),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "div",
                  { staticClass: "control is-expanded" },
                  [
                    _c("datepicker", {
                      attrs: {
                        "full-month-name": false,
                        selected: "2018-11-22",
                        "input-class": "input ",
                        language: "en",
                        format: "dd/MM/yyyy",
                        id: "estStartDate",
                        name: "estStartDate",
                        placeholder: "Select Date"
                      },
                      model: {
                        value: _vm.taskModel.estStartDate,
                        callback: function($$v) {
                          _vm.$set(_vm.taskModel, "estStartDate", $$v)
                        },
                        expression: "taskModel.estStartDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(9),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c(
                  "div",
                  { staticClass: "control is-expanded" },
                  [
                    _c("datepicker", {
                      attrs: {
                        "input-class": "input",
                        language: "en",
                        format: "dd/MM/yyyy",
                        id: "estFinishDate",
                        name: "estFinishDate",
                        placeholder: "Select Date"
                      },
                      model: {
                        value: _vm.taskModel.estFinishDate,
                        callback: function($$v) {
                          _vm.$set(_vm.taskModel, "estFinishDate", $$v)
                        },
                        expression: "taskModel.estFinishDate"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(10),
            _c(
              "div",
              { staticClass: "field-body is-expanded" },
              [_c("upload", { ref: "upload", staticStyle: { width: "100%" } })],
              1
            )
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _vm._m(11),
            _c("div", { staticClass: "field-body" }, [
              _c("div", { staticClass: "field" }, [
                _c("div", { staticClass: "control " }, [
                  _c(
                    "ul",
                    _vm._l(_vm.files, function(file, index) {
                      return _c("li", { key: index }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.projectFile,
                              expression: "projectFile"
                            }
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            value: file.id,
                            checked: Array.isArray(_vm.projectFile)
                              ? _vm._i(_vm.projectFile, file.id) > -1
                              : _vm.projectFile
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.projectFile,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = file.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.projectFile = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.projectFile = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.projectFile = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(
                          _vm._s(file.orgFileName) +
                            "\n                        "
                        )
                      ])
                    })
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "field is-horizontal" }, [
            _c(
              "div",
              { staticClass: "field-label is-normal" },
              [
                _c("isButton", {
                  ref: "btnCreate",
                  attrs: {
                    onClick: _vm.createProdTask,
                    title: "CreateTask",
                    state: true
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { attrs: { lass: "is-active" } }, [
      _c("a", { attrs: { href: "#", "aria-current": "page" } }, [
        _vm._v("Create Production Task")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "is-clearfix" }, [_c("br")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Status")]),
        _c("th", [_vm._v("Task No")]),
        _c("th", [_vm._v("Task Name")]),
        _c("th", [_vm._v("Partner")]),
        _c("th", [_vm._v("Est. Start Date")]),
        _c("th", [_vm._v("Est. Finish Date")]),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "title is-3" }, [
      _c("i", { staticClass: "fa fa-file-o" }),
      _vm._v("  Create New Task")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Name *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Detail *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Partner *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Request LeadTime *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Est. StartDate")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Est. Finish")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Upload")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "field-label is-normal" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Project Files")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f3338cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3338cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/tasks/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0f3338cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/tasks/_id.vue
// module chunks = 33